import storefrontInstance from '@/api/instances/storefront';

const powerReviewsModule = {
  namespaced: true,

  state: {
    productDetails: {},
    isWindowPwrLoaded: false,
    isLoadingScript: false,
  },
  getters: {
    productDetails: (state) => state.productDetails,
  },

  mutations: {
    setProductDetails(state, payload) {
      state['productDetails'] = payload;
    },

    setIsLoadingScript(state, payload) {
      state['isLoadingScript'] = payload;
    },

    setIsWindowPwrLoaded(state, payload) {
      state['isWindowPwrLoaded'] = payload;
    },
  },
  actions: {
    async fetchProductReviews({state}, payload) {
      try {
        const response = await storefrontInstance.get(
          `https://readservices-b2c.powerreviews.com/m/4404/l/en_US/product/${payload}/reviews?apikey=${state.productDetails.pr_api_key}`
        );
        return response.data;
      } catch (error) {
        console.error(error);
        return error;
      }
    },
  },
};

export default powerReviewsModule;
